export const PAGE_TITLES = Object.freeze({
    CREATE: 'Zamawianie nowego dokumentu',
    EDIT: 'Edycja zamówienia dokumentu'
})

export const ACTION_TYPES = Object.freeze({
    CREATE: 'create',
    EDIT: 'edit'
})

const RAW_TAB_ITEMS = Object.freeze([
    {
        label: 'Szczegóły',
        visible: true,
        disabled: false
    },
    {
        label: 'Załączniki',
        visible: true,
        disabled: false
    },
    {
        label: 'Komentarze',
        visible: true,
        disabled: false
    }
])

export const STATUSES = Object.freeze({
    DONE: 90
})

export const createTabItems = () => RAW_TAB_ITEMS.map(item => ({ ...item }))
